import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { LiberisContext } from './liberis-context';
export function LiberisContextProvider(_a) {
    var children = _a.children;
    var _b = useState('AMOUNT'), liberisStage = _b[0], setLiberisStage = _b[1];
    var _c = useState(0), activeBeneficientIndex = _c[0], setActiveBeneficientIndex = _c[1];
    return (_jsx(LiberisContext.Provider, { value: {
            liberisStage: liberisStage,
            setLiberisStage: setLiberisStage,
            activeBeneficientIndex: activeBeneficientIndex,
            setActiveBeneficientIndex: setActiveBeneficientIndex,
        }, children: children }));
}
